import React from "react";
import { useLang } from "../context/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div
      data-testid="marquee-section"
      className="relative border-y border-white/10 bg-black py-6 overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee gap-10">
        {row.map((word, i) => (
          <span
            key={i}
            className="font-display text-4xl md:text-5xl text-white/70 flex items-center gap-10"
          >
            {word}
            <span className="inline-block w-2 h-2 bg-[#FFCC00] rotate-45 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
}
